import { format, isValid } from 'date-fns';

export const isSameDate = (date1?: Date, date2?: Date) => {
  if ((!date1 || !date2) && date1 !== date2) {
    return false;
  }

  const date1String = date1 && isValid(date1) && format(date1, 'yyyy-MM-dd');
  const date2String = date2 && isValid(date2) && format(date2, 'yyyy-MM-dd');

  return date1String === date2String;
};
